import { Compact } from './Compact';
import { Full } from './Full';

export type LogoProps = {
  /** If is text+icon or only icon */
  expanded?: boolean;
  /** Logo size */
  size?: 'small' | 'medium' | 'large';
  /** Logo color */
  color?: 'blue' | 'black' | 'white' | 'red' | 'orange';
  /**
   * ID to be used in unit or automated tests.
   * Will result in 2 different attributes:
   * * ${testId}-onlyLogo
   * * ${testId}-full
   */
  testId: string;
};

export type DescendantLogoProps = Required<Pick<LogoProps, 'size' | 'color' | 'testId'>>;

export const Logo = ({ size = 'small', color = 'blue', expanded, testId }: LogoProps) => {
  if (!expanded) {
    return <Compact color={color} size={size} testId={`${testId}-onlyLogo`} />;
  } else {
    return <Full color={color} size={size} testId={`${testId}-full`} />;
  }
};
